import { RefundDestinationEnum } from '@insurance/api/requests'
import { Select, SelectProps } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = SelectProps

const refundDestinations = Object.values(RefundDestinationEnum)

export const RefundDestinationsSelect = (props: Props) => {
  const { t } = useTranslation()

  return (
    <Select
      placeholder={t('refund_destination')}
      options={refundDestinations.map((value) => ({
        label: t(`${value}_label`),
        value
      }))}
      {...props}
    />
  )
}
